import { Link } from 'react-router-dom';

export default function AboutArticleSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Text Side */}
          <div className="flex-1 max-w-[560px] lg:max-w-none">
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 mb-4">In-Depth Guide</span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-5">
              How to Master<br />LitBuy Spreadsheet
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-[480px]">
              Discover everything you need to know about LitBuy Spreadsheet in our comprehensive guide. From setup and basic tracking to advanced deal analytics and cross-category comparison strategies — this guide covers it all with step-by-step tutorials and practical examples for Shoes, Hoodies, T-Shirts, Jackets, and every other category you shop.
            </p>
            <p className="text-sm text-foreground-500 leading-relaxed mb-8 max-w-[480px]">
              Whether you are a first-time LitBuy Spreadsheet user exploring deal tracking for the first time, or an experienced shopper looking to optimize your workflow across all 14 product categories, this guide provides actionable insights you can implement today.
            </p>
            <Link
              to="/blog/litbuy-spreadsheet-complete-guide"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line"></i>
              Read Full Guide
              <i className="ri-arrow-right-line"></i>
            </Link>

            {/* Quick stats */}
            <div className="flex items-center gap-8 mt-10">
              <div>
                <span className="block font-heading text-2xl font-bold text-foreground-950">3,000+</span>
                <span className="text-xs text-foreground-500">Words Guide</span>
              </div>
              <div>
                <span className="block font-heading text-2xl font-bold text-foreground-950">14</span>
                <span className="text-xs text-foreground-500">Categories Covered</span>
              </div>
              <div>
                <span className="block font-heading text-2xl font-bold text-foreground-950">Step-by-Step</span>
                <span className="text-xs text-foreground-500">Tutorials</span>
              </div>
            </div>
          </div>

          {/* Image Side */}
          <div className="flex-1 flex gap-4 w-full">
            <div className="w-[45%] aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20tablet%20displaying%20colorful%20spreadsheet%20charts%20and%20graphs%20on%20a%20bright%20marble%20desk%20with%20a%20coffee%20cup%2C%20fresh%20flowers%20in%20vase%2C%20productive%20workspace%2C%20warm%20morning%20sunlight%2C%20creative%20professional%20environment&width=600&height=800&seq=guide-img-v2-001&orientation=portrait"
                alt="LitBuy Spreadsheet interface showing deal tracking dashboard"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-[55%] aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Diverse%20collection%20of%20stylish%20fashion%20items%20including%20sneakers%20jacket%20bag%20and%20hat%20displayed%20on%20a%20circular%20wooden%20table%2C%20Scandinavian%20interior%20with%20plants%2C%20bright%20natural%20daylight%2C%20minimal%20lifestyle%20photography&width=800&height=1000&seq=guide-img-v2-002&orientation=portrait"
                alt="Product categories covered by LitBuy Spreadsheet"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}